import {UserStatus} from "../api/psc.ts";
import {Colors} from "./ColorConstants";

export const UserStatusDefinitions = [
    {
        id: UserStatus.ACTIVE,
        color: Colors.Success,
        title: "فعال"
    },
    {
        id: UserStatus.DE_ACTIVE,
        color: Colors.Warning,
        title: "غیر فعال"
    },
    {
        id: UserStatus.SOFT_DELETED,
        color: Colors.Error,
        title: "خذف شده"
    }
]
